import { useMutation, UseMutationResult } from '@tanstack/react-query'

interface IUseMutationHookProps<TProps, TData, TError = Error> {
  path: string
  mutationKey?: string[]
  mutationFn: (url: string, props: TProps) => Promise<TData>
  onSuccess?: (data: TData) => void
  onError?: (error: TError, variables: TProps, context: unknown) => void
}

export function useMutationHook<TProps, TData, TError = Error>({
  path,
  mutationKey = [path],
  mutationFn,
  onSuccess,
  onError,
}: IUseMutationHookProps<TProps, TData, TError>): UseMutationResult<TData, TError, TProps> {
  return useMutation<TData, TError, TProps>({
    mutationKey,
    mutationFn: (body: TProps) => mutationFn(path, body),
    onSuccess,
    onError,
  })
}
